import React from 'react';

import {
  Modal,
} from 'react-bootstrap';

import {Viewer} from '@react-pdf-viewer/core';
import {Worker} from '@react-pdf-viewer/core';


const ModalViewConciergerie = ({showModal, setShowModal, showDoclink}) => {
  return (
    <>
      <Modal
        id="Docmodal"
        size="lg"
        className="modal modal-primary"
        show={showModal}
        onHide={() => setShowModal(false)}
      >
        <div className="pdf-container" style={{height: '80vh'}}>
          {/* show pdf conditionally (if we have one)  */}
          {showDoclink && (
            <>
              <Worker workerUrl="https://unpkg.com/pdfjs-dist@2.6.347/build/pdf.worker.min.js">
                <Viewer
                  fileUrl={showDoclink}
                  theme="auto"
                />
              </Worker>
            </>
          )}
          {/* if we dont have pdf or viewPdf state is null */}
        </div>
      </Modal>
    </>
  );
};

export default ModalViewConciergerie;
